

import PricingButton from "@/components/main/pricing/PricingButton";

export default {
  name: "GreyHeadBox",
  props: ['title', 'text', 'startingFrom', 'sale', 'popular', 'img', 'box', 'lnk', 'fullHeight'],
  components: {PricingButton}
}
